module.exports = __webpack_public_path__ + "gameIcon.png?f0f318d09cc3c9afe9139ea8df634863";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gameIcon.png
// module id = 51
// module chunks = 0